import { CourseTypes } from "../types/enums/CourseTypes";
import { DateCheck } from "../types/enums/DateCheckResults";
import { FreeOrPaid } from "../types/enums/FreeOrPaid";
import { SKU, TestDetail } from "../types/interfaces/CourseBasicDetails"
import * as XLSX from 'xlsx';
import { BasicInfo } from "../types/interfaces/BasicInfo";
import _ from "lodash";
import ACLService from '../../acl/services/aclService';
import { USER_RIGHTS } from '../../../constants/comman';
import { COURSES_TAB, COURSE_BASE_IMAGE_URL, ENTITY_TYPE, TEST_SERIES_EDIT } from '../Constants/constants';
import { getQueryParams } from '../../../utils';
import { REQUEST_STATUS } from '../types/enums/RequestStatus';

export const buildSKUString = (sku: SKU) => {
    const { SKUText, SKUNumber, SKUYear } = sku;
    return `${SKUText}-${SKUNumber}-${SKUYear && SKUYear.toString().trim()}`
}

export const buildComboSKUString = (sku: SKU,year : string) => {
    const { SKUText, SKUNumber, SKUYear } = sku;
    return `${SKUText}-${SKUNumber}-${year}`
}

export const getCreateCourseDefaultFormData = (defaultAdmin?: any) => {
    return {
        name: '',
        sku: {
            SKUText:'',
            SKUNumber: 0,
            SKUYear: (new Date().getFullYear())
        },
        courseDetails: [], // for course
        goalsDetails: '', // For goal.
        startDate: {
            label: '',
            value: ''
        }
        ,
        endDate: {
            label: '',
            value: ''
        }
        ,
        selectedCourses : [],
        primaryCourse : ' ',
        primaryGoal: '',
        contentPreferences: {
            scheduledTests: {
                enabled: true
            },
            chapterTests: {
                enabled: true
            },
            conceptTests: {
                enabled: true
            },
            studyNotes: {
                enabled: true
            },
            video: {
                enabled: true
            },
            formulas: {
                enabled: true
            },
            mainTests: {
                enabled: false
            },
            sampleTests: {
                enabled: false
            }
        },
        // packageAdmins: [defaultAdmin],
        packageAdmins: defaultAdmin?[defaultAdmin]:[],
        courses:[],
        goals:[],
        goalLevels:[],
        masterId:'',
        onboardingIntervals:{
            startDate:"",
            endDate:''
        },
         description:'',
        phaseAlignment:{
            id:"",
            name:"",
            startDate:"",
            endDate:""
        },
        type: CourseTypes.standard,
        targetYears:[],
        expiryDate:'',
        includedPackages: [],
        duration: 0
    }
}

export const getCreateCourseInitailStateForErrors = () => {
    return {
        name: 'untouched',
        sku: {
            SKUText:'untouched',
            SKUNumber: 'untouched',
        },
        courseDetails: 'untouched',
        goalsDetails: 'untouched',
        startDate: 'untouched',
        primaryCourse: 'untouched',
        primaryGoal: 'untouched',
        endDate: 'untouched',
        contentPreferences: '', // Check if we can remove this
        packageAdmins: '',
        type: '' // Check if we can remove this
    }
}

export const getDefaultAdvancedSettings = () => {
    return {
        availableForB2C: true,
        availableForTestUsers: true,
        sellsOutsideIndia: false,
        isPaid: FreeOrPaid.paid,
        price: 0,
        discount: 0,
        localeWisePrice: [],
        otherInfo: {
            mainTests: '',
            conceptTests: ''
        },
        FAQ: [],
        metatags: {
            title:'',
            description:'',
            keywords:''
        }
    }
}
export const getDefaultGeneralSettings = () => {
    return {
        availableForB2C: false,
        availableForCRP: false,
        availableForNCRP: false,
        availableForTestUsers: false,
        sellsOutsideIndia: false,
        isPaid: FreeOrPaid.paid,
        price: 0,
        discount: 0,
        localeWisePrice: [{
            locale: 'IN',
            price: 1,
            discount: 0
        }],
        otherInfo: {
            mainTests: '',
            conceptTests: ''
        }
    }
}
export const getDefaultFAQ = () => {
    return {
        FAQ: [{
            question: '',
            answer: '',
        },
        {
            question: '',
            answer: '',
        }]
    }
}
export const getDefaultSEO = () => {
    return {
        metatags: {
            title:'',
            description:'',
            keywords:''
        }
    }
}




// ================================VALIDATIONS=============================

export const checkMinLength = (text: string, minLength: number) => {
    const result = text && text.length >= minLength ? true : false;
    return result;
}
export const isContainSpecialCharacters=(text:string)=>{
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      return format.test(text);
}
export const isNumericInput = (value: any) => {
    if(typeof value === 'number') {
        return true;
    } else {
        return false;
    }
}

export const checkStartAndEndDate = (startDate: string, endDate: string) => {
    let checkResult:DateCheck = DateCheck.validDates;
    
    const today = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);


    if(start > end){
        checkResult = DateCheck.startGreaterThanEnd;
    }

    if(end < start){
        checkResult = DateCheck.endLessThanStart;
    }

    return checkResult;
}
export const getStatusType=(statusCode:number)=>{
    switch (statusCode.toString().charAt(0)){
        case "1":
             return "1xx";
        case "2":
              return "2xx"; 
        case "3":
             return "3xx";
        case "4":
              return "4xx";
      default:
              return "5xx";                    
  
    }
  }
export const  getDeafultTestDetail=()=>{
    const testDeatil:TestDetail={
      duration : '180',
      type : 'full',
      courseId : '',
      name : '',
      testId : '000000000000000000000000',
      revisionTime : '', 
      endDate: '',
      startDate : '',
      syllabus :'',
      scheduleID : '',
      maxAttempts:'',
      questionsCount: 0
    }
    return testDeatil;
  }
  export const createErrorSheet = (readyToExport:any,fileName:string) => {
    // const readyToExport = [
    //   {id: 1, name: 'a'},
    //   {id: 2, name: 'b'},
    //   {id: 3, name: 'c'}
    // ];

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(readyToExport);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, fileName); // initiate a file download in browser
}  

export const getGeneralSetting = (packageData:BasicInfo) => {
    return {
      availableForB2C: packageData.availableForB2C,
      availableForCRP: packageData.availableForCRP,
      availableForNCRP: packageData.availableForNCRP,
      availableForTestUsers: packageData.availableForTestUsers,
      sellsOutsideIndia: packageData && packageData.localeWisePrice && packageData.localeWisePrice.length > 0 ? true : false, // NOT RECEIVING FROM BACKEND, CHECK
      isPaid: packageData.isPaid ? FreeOrPaid.paid : FreeOrPaid.free,
      price: packageData.price,
      discount: packageData.discount,
      localeWisePrice: !_.isEmpty(packageData.localeWisePrice) ? packageData.localeWisePrice : [{  // NOT RECEIVING FROM BACKEND, CHECK
        locale: 'IN',
        price: 1,
        discount: 0
    }],
      otherInfo: packageData.otherInfo
   }
}
export const escapeRegExp =(str:string) =>{
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }


// Reading Main Tests
export const flattenMainTests = (coursePlanData: any) => {
    const phases  = _.get(coursePlanData, 'phases', []);
    phases.forEach((phase: any) => {
        const weeks = _.get(phase, 'weeks', []);
        weeks.forEach((week:any) => {
            const content = _.get(week, 'content', []);
            const newContent = content.map((testData: any) => {
                return testData.testDetails ? testData.testDetails : testData;
            })
            week.content = newContent;
        })
    })
    return coursePlanData;
}

// While Sending Put Request
export const transformMainTests = (data: any) => {
    const coursePlanData = JSON.parse(JSON.stringify(data));
    const phases  = _.get(coursePlanData, 'phases', []);
    phases.forEach((phase: any) => {
        const weeks = _.get(phase, 'weeks', []);
        weeks.forEach((week:any) => {
            const content = _.get(week, 'content', []);
            const newContent = content.map((testData: any) => {
                return {
                    type: 'test',
                    title: testData.name,
                    contentId:testData.contentId,
                    testDetails: testData,
                    bonusCriteria: [],
                    isBonus: false,
                    description: '',
                    id: testData.testId
                };
            })
            week.content = newContent;
        })
    })
    
    return coursePlanData;
}


export const checkIfTestInThisPhase = (
    testStart: Date,
    testEnd: Date,
    phaseStart: Date,
    phaseEnd: Date,
    nextPhaseStartDate: Date
) => {
    const isTestStartGreaterThanPhaseStart = testStart > phaseStart;
    let isTestStartLessThanNextPhaseStart, isMilestoneTestInThisPhase;
    if(nextPhaseStartDate) {
        isTestStartLessThanNextPhaseStart = testStart < nextPhaseStartDate;
        isMilestoneTestInThisPhase = isTestStartGreaterThanPhaseStart && isTestStartLessThanNextPhaseStart;
    } else {
        isMilestoneTestInThisPhase = isTestStartGreaterThanPhaseStart
    }
    return isMilestoneTestInThisPhase;
};

export const checkIfMainTestInThisWeek = (
    testStart: Date,
    testEnd: Date,
    weekStart: Date,
    weekEnd: Date
) => {
    const isTestStartGreaterThanWeekStart = testStart >= weekStart;
    const isTestStartLessThanWeekEnd = testStart <= weekEnd;
    const isMainTestInThisWeek = isTestStartGreaterThanWeekStart && isTestStartLessThanWeekEnd;
    return isMainTestInThisWeek;
};

export const processBulkDragPayload = (treeData:any, payload: any) => {
    const { bulkDrag:bulkDragFromPayload } = payload;
    let bulkDrag = {...bulkDragFromPayload}
    const keys = Object.keys(bulkDragFromPayload);
    const chapterKeys:any={};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const keyInfo = key.split('-').filter((key) => key !== '-');
        const phaseIndex = keyInfo[1];
        const weekIndex =  keyInfo[2];
        const subjectIndex = keyInfo[3];
        const chapterIndex = keyInfo[4];
        
        
        if(keyInfo[0] === 'chapter'){
            if( treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex] != undefined){
                const lengthOfConcepts = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts.length;
                for(let x = 0; x < lengthOfConcepts; x++){
                    const newKey = `concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${x}`;
                    bulkDrag[newKey] = true;
                }
            }
           
        }

        let chapter;
        if(keyInfo[0] === 'concept'){
            let conceptIndex = keyInfo[5];
           // if( treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex] != undefined){
                chapter = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex];
                const chapterKey= `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`;
               if(!bulkDrag[key]){
                  delete bulkDrag[chapterKey];
               }
              else{
               if(chapterKeys.hasOwnProperty(chapterKey)){
                chapterKeys[chapterKey]+=1;
               }else{
                chapterKeys[chapterKey]=1;
               }   
              }
              if(chapterKeys[chapterKey]==chapter.concepts.length){
                  bulkDrag[chapterKey]=true;
              }
            //     let conceptKeys = keys.filter((key:any) => key.split('-')[0] === 'concept');
            //     let conceptKeysOfChapter = conceptKeys.filter((key:any) => {
            //         let keyData = key.split('-').filter((x:any) => x !== '-');
            //         const phase = keyData[1]
            //         const week = keyData[2]
            //         const subject = keyData[3]
            //         const chapter = keyData[4]
            //         if(
            //             phase === phaseIndex &&
            //             week === weekIndex &&
            //             subject === subjectIndex &&
            //             chapter === chapterIndex
            //         ) {
            //             return key;
            //         }
            //     })
    
            //     let countOfConceptKeys = conceptKeysOfChapter.length;
            //     if(chapter!=undefined){
            //      const lengthOfChapterConcepts = chapter.concepts.length;
            //    if(lengthOfChapterConcepts !== countOfConceptKeys){
            //         const chapterKeyToDelete = `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`;
            //         delete bulkDrag[chapterKeyToDelete]
            //     }
            // }
        
        }
    }
    return {bulkDrag};
}

export function makeDeepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}

export function checkForNoRight(moduleName: string) {
    const user = ACLService.getUserDetailsFromStorage();
    let noUserRight;
    try {
        noUserRight = user.authenticatedUser.role.permissions.filter((modulePermission: any) =>
            modulePermission.module === moduleName && modulePermission.access.includes(USER_RIGHTS.NONE)
        ).length;
    } catch (error) {
        noUserRight = false;
    }

    return !!noUserRight;
}

export function checkForCreationForRight(moduleName: string) {
    const user = ACLService.getUserDetailsFromStorage();
    let userCreateContentRight;
    try {
        userCreateContentRight = user.authenticatedUser.role.permissions.filter((modulePermission: any) =>
            modulePermission.module === moduleName && modulePermission.access.includes(USER_RIGHTS.CREATE)
        ).length;
    } catch (error) {
        userCreateContentRight = false;
    }

    return !!userCreateContentRight;
}

export function checkForCreatedByUser(content: any) {
    const user = ACLService.getUserDetailsFromStorage();
    let createdByUser;
    try {
        createdByUser = content.aclMetaData.createdBy.email === user.authenticatedUser.email;
    } catch (error) {
        createdByUser = false;
    }

    return createdByUser;
}

export function checkForEditRight(content: any, moduleName: string) {
    const user = ACLService.getUserDetailsFromStorage();
    let editRights;
    try {
        const authenticatedUser = user.authenticatedUser;
        const userEditRight = authenticatedUser.role.permissions.filter((modulePermission: any) =>
            modulePermission.module === moduleName && modulePermission.access.includes(USER_RIGHTS.EDIT)
        ).length;

        editRights = userEditRight || checkForCreatedByUser(content);

    } catch (error) {
        editRights = false;
    }

    return !!editRights;
}

export function checkForPublishRight(moduleName: string) {
    const user = ACLService.getUserDetailsFromStorage();
    let publishRight;
    try {
        const authenticatedUser = user.authenticatedUser;
        publishRight = authenticatedUser.role.permissions.some((modulePermission: any) =>
            modulePermission.module === moduleName && modulePermission.access.includes(USER_RIGHTS.PUBLISH)
        );
    } catch (error) {
        publishRight = false;
    }

    return !!publishRight;
}

export function redirectToCourseEdit(type: string, courseId: string, coursePlanId: string, editingCourse: boolean, requestId: string) {
    return `/course-Management/create-${type}-course/${courseId}?coursePlanId=${coursePlanId}&editingCourse=${editingCourse}&requestId=${requestId}`;
}

export function redirectToTestseriesPreview(courseId: string, requestId: string = '') {
    return `/course-Management/testSeries/${courseId}/preview?requestId=${requestId}`;
}

export function redirectToCoursePreview(courseId: string, requestId: string = '') {
    return `/course-Management/coursePlanPreview/${courseId}?requestId=${requestId}`;
}

export function convertToDateTimeString(date: string) {
    const originalDate = new Date(date);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedDate = `${originalDate.getDate()} ${monthNames[originalDate.getMonth()]} - ${originalDate.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
    return formattedDate;
}

export function redirectToTestSeriesEdit(courseId: string, requestId: string): string {
    return `${TEST_SERIES_EDIT}/${courseId}?requestId=${requestId}`;
}

export function redirectToCourseRequest(packageDetails: any) {
    const { _id, packageId, courseType = CourseTypes.standard } = packageDetails;
    let redirectUrl = '';
    if (courseType === CourseTypes.testSeries) {
        redirectUrl = redirectToTestseriesPreview(packageId, _id);
    } else {
        redirectUrl = redirectToCoursePreview(packageId, _id);
    }

    return redirectUrl;
}

export function getImageSource(contentType: string) {
    let baseUrl = COURSE_BASE_IMAGE_URL;
    switch (contentType) {
        case ENTITY_TYPE.ADMIN:
            baseUrl += '/admin-ic.svg';
            break;
        case ENTITY_TYPE.COURSE:
            baseUrl += '/course-ic.svg';
            break;
        case ENTITY_TYPE.CHAPTER:
            baseUrl += '/chapter-ic.svg';
            break;
        case ENTITY_TYPE.CONCEPT:
            baseUrl += '/concept-ic.svg';
            break;
        case ENTITY_TYPE.TEST:
            baseUrl += '/chapter-test-ic.svg';
            break;
        case ENTITY_TYPE.NOTES:
            baseUrl += '/notes-ic.svg';
            break;
        case ENTITY_TYPE.FORMULA:
            baseUrl += '/formula-ic.svg';
            break;
        case ENTITY_TYPE.VIDEO:
            baseUrl += '/video-ic.svg';
            break;
        case ENTITY_TYPE.AUDIO:
            baseUrl += '/audio-ic.svg';
            break;

        default: baseUrl += '/course-ic.svg';

    }

    return baseUrl;
}

export function getRequestId() {
    return getQueryParams(document.location.search, 'requestId');
}

export function redirectionToCourseManagement(requestStatus = REQUEST_STATUS.AWAITING) {
    setTimeout(() => {
        let newCourseUrl = `/course-Management?activeTab=${COURSES_TAB.COURSE_CHANGE_REQUEST}&requestStatus=${requestStatus}`;
        window.location.href = newCourseUrl;
    }, 1000);
}

export function redirectionToCourseListing() {
    window.location.href = `/course-Management`;
}